/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dispatch_Delivery_Dropoff_LabelInputs */

const en_dispatch_delivery_dropoff_label = /** @type {(inputs: Dispatch_Delivery_Dropoff_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dropoff`)
};

const fr_dispatch_delivery_dropoff_label = /** @type {(inputs: Dispatch_Delivery_Dropoff_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Livraison`)
};

const ms_sg2_dispatch_delivery_dropoff_label = /** @type {(inputs: Dispatch_Delivery_Dropoff_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penghantaran`)
};

/**
* | output |
* | --- |
* | "Dropoff" |
*
* @param {Dispatch_Delivery_Dropoff_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const dispatch_delivery_dropoff_label = /** @type {((inputs?: Dispatch_Delivery_Dropoff_LabelInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dispatch_Delivery_Dropoff_LabelInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dispatch_delivery_dropoff_label(inputs)
	if (locale === "fr") return fr_dispatch_delivery_dropoff_label(inputs)
	return ms_sg2_dispatch_delivery_dropoff_label(inputs)
});